<template>
  <div>
    <el-card class="box-card div-center ">
      <div slot="header" style="height: 40px">
        <span style="font-size: larger">{{informationInfo.name}}</span>
        <el-button style="float: right;" type="success" @click.native="onSubmitPublic">更新应用</el-button>
      </div>
      <div>
        <div style="width: 100%">
          <el-row >
            <el-col :span="3">
              <div>
                <el-image class="div-center-logo" :src="informationInfo.icon"/>
              </div>
            </el-col>
            <el-col :span="20">
              <el-row style="height: 100%;" align="middle">
                <el-col :span="9">
                  <div class="div-center-label-top">
                    <label class="div-center-label">PackageName:<span class="div-center-label-span">{{informationInfo.packageName}}</span></label>
                  </div>
                  <div class="div-center-label-top">
                    <label class="div-center-label">大小:<span class="div-center-label-span">{{informationInfo.size}} MB</span></label>
                  </div>
                  <div class="div-center-label-top">
                    <label class="div-center-label">MinSdkVersion:<span class="div-center-label-span">{{informationInfo.minSdkVersion}}</span></label>
                  </div>
                  <div class="div-center-label-top">
                    <el-link class="div-center-label-span" @click="jumpUrl(informationInfo.url)">应用链接：
                      {{informationInfo.url}}
                    </el-link>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div class="div-center-label-top">
                    <label class="div-center-label">VersionCode:<span class="div-center-label-span">{{informationInfo.versionCode}}</span></label>
                  </div>
                  <div class="div-center-label-top">
                    <label class="div-center-label">VersionName:<span class="div-center-label-span">{{informationInfo.versionName}}</span></label>
                  </div>
                  <div class="div-center-label-top">
                    <label class="div-center-label">TargetSdkVersion:<span class="div-center-label-span">{{informationInfo.targetSdkVersion}}</span></label>
                  </div>
                </el-col>
                <el-col :span="6" type="flex">
                  <div class="div-center-url">
                    <el-image class="div-center-code" :src="informationInfo.code"/>
                    <el-link class="div-center-label" @click="downloadCode()">点击下载：512x512</el-link>
                  </div>

                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
    <div>
      <vxe-table border="inner" style="height: 100%;font-size: 16px" :data="packageInfo"  align="center"
                 :row-style="{height:'20px'}"  :cell-style="{padding:'6px'}"  highlight-hover-row>
        <vxe-table-column  field="versionName" width="200" title="版本"></vxe-table-column>
        <vxe-table-column  field="targetSdkVersion" title="TargetSdkVersion" ></vxe-table-column>
        <vxe-table-column field="size"  width="200" title="大小"></vxe-table-column>
        <vxe-table-column field="downloadCount" title="下载次数"></vxe-table-column>
        <vxe-table-column field="buildTime" title="更新时间"></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainAPPCenter',
  mounted () {
    let vm = this
    console.log('mounted')
    this.bus.$on('busChangeAppCenter', (key) => {
      vm.id = key
      console.log('busChangeAppCenter:', key, this.id)
      this.getPackHistory()
    })
  },
  created () {
    // this.getPackHistory()
    console.log('id', this.id)
  },
  data () {
    return {
      id: 0,
      tableData: [],
      pageNum: 1,
      pageSize: 8,
      informationInfo: {
        name: 'undefined',
        packageName: 'undefined',
        size: 0,
        url: '',
        code: '../static/ic_launcher_round.png',
        icon: '../static/ic_launcher_round.png',
        versionName: '0.0',
        versionCode: 0,
        minSdkVersion: '0',
        targetSdkVersion: '0'
      },
      packageInfo: [{
        id: 0,
        versionName: '0.0',
        size: 0,
        targetSdkVersion: 0,
        downloadCount: '0',
        buildTime: '1979-01-01'
      }]
    }
  },
  methods: {
    onSubmitPublic () {
      // 调用兄弟组件的方法
      this.bus.$emit('busChangeHead', '1')
    },
    getPackHistory () {
      this.$axios({
        url: this.$global.baseURL.concat('main/apkCenterHistory?id=').concat(this.id).concat('&pageNum=').concat(this.pageNum)
          .concat('&pageSize=').concat(this.pageSize),
        method: 'get'
      }).then(successResponse => {
        console.log(successResponse.data.data)
        if (successResponse.data.code === 200) {
          let packages = successResponse.data.data.packageInfos
          let tmpInformation = successResponse.data.data.informationInfo
          if (tmpInformation !== undefined) {
            // 重新刷新数据
            this.informationInfo.name = tmpInformation.name
            this.informationInfo.icon = this.$global.baseURL.concat(tmpInformation.image)
            this.informationInfo.url = tmpInformation.url
            console.log('informationInfo:', this.informationInfo)
            this.informationInfo.code = this.$global.baseURL.concat(tmpInformation.code)
          } else {
            tmpInformation = ''
          }
          let tmpItems = []
          if (packages.length > 0) {
            this.informationInfo.size = packages[0].size
            this.informationInfo.versionName = packages[0].versionName
            this.informationInfo.versionCode = packages[0].versionCode
            this.informationInfo.minSdkVersion = packages[0].minSdkVersion
            this.informationInfo.targetSdkVersion = packages[0].targetSdkVersion
            this.informationInfo.packageName = packages[0].packageName
            console.log('packages[0]:', packages[0])
            console.log('informationInfo:', this.informationInfo)
            for (let i = 0; i < packages.length; i++) {
              tmpItems.push({id: packages.length - i,
                versionName: packages[i].versionName,
                size: packages[i].size,
                targetSdkVersion: packages[i].targetSdkVersion,
                downloadCount: packages[i].downloadCount,
                buildTime: packages[i].buildTime})
            }
          } else {
            this.informationInfo.packageName = ''
          }
          this.packageInfo = tmpItems
          this.$forceUpdate()
        }
      })
    },
    downloadCode () {
      let link = document.createElement('a')
      let url = this.informationInfo.code
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob)
        link.download = this.informationInfo.name.concat('.png')
        document.body.appendChild(link)
        link.click()
      })
    },
    jumpUrl (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
.div-center-logo{
  width: 80px;
  height: 80px;
  padding-top: 20px;
}
.div-center-code{
  width: 120px;
  height: 120px;
  padding-top: 20px;
}
.div-center-label{
  font-size: medium;
  color: black;
}
.div-center-label-span{
  font-size: medium;
  color: dodgerblue;
}
.div-center-url{
  display: flex;align-items:center;justify-content: center;
}

.div-center-label-top{
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainAPPCenter.vue